module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_5.4ad18db8.png";